import { render, staticRenderFns } from "./moveDialog.vue?vue&type=template&id=103a9627&scoped=true&"
import script from "./moveDialog.vue?vue&type=script&lang=js&"
export * from "./moveDialog.vue?vue&type=script&lang=js&"
import style0 from "./moveDialog.vue?vue&type=style&index=0&id=103a9627&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103a9627",
  null
  
)

export default component.exports